export default __webpack_public_path__ + "static/media/clipart.f2d491ab.svg";